module.exports = "pegasus_template/assets/themelp1/charity/108.png";